/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-system-vars-accounting-tab',
  templateUrl: 'system-vars-accounting-tab.component.html',
})
export class SystemVarsAccountingTabComponent {
}
